import { render, staticRenderFns } from "./Advogados.vue?vue&type=template&id=acebd2f2&scoped=true&"
import script from "./Advogados.vue?vue&type=script&lang=js&"
export * from "./Advogados.vue?vue&type=script&lang=js&"
import style0 from "./Advogados.vue?vue&type=style&index=0&id=acebd2f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acebd2f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VFlex,VLayout})
